import { State } from 'xstate';

import { createSubscriptionMachine } from './subscription';

type SubscriptionMachine = ReturnType<typeof createSubscriptionMachine>;

type SubscriptionState = State<SubscriptionMachine['context']>;

export const getSubscriptionState = (machineState: SubscriptionState) =>
  machineState.context.status;

export const getAddedCoupon = (state: SubscriptionState) =>
  state.context.addedCoupon;
export const getError = (state: SubscriptionState) => state.context.error;
export const getCouponsStatus = (state: SubscriptionState) => {
  return {
    isError: state.matches('error'),
    isLoading: state.matches('loading'),
    isAddingCoupon: state.matches('addingCoupon'),
    isCouponAdded: state.matches('couponAdded'),
  };
};

export const getCoupons = (state: SubscriptionState) => state.context.coupons;

export const getSubscriptionDetails = (machineState: SubscriptionState) => {
  const isLoading = machineState.matches('loadingSubscriptionDetails');

  const {
    id,
    status,
    currency,
    currentBillingAmountInCents,
    currentPeriodEndsAt,
    scheduledCancellationAt,
    nextAssessmentAt,
    canceledAt,
    expiresAt,
    trialEndedAt,
    balanceInCents,
    automaticallyResumeAt,
    product,
    billing,
    customFields,
    referralCode,
    threeDsActionLink,
    coupons,
  } = machineState.context;

  return {
    id,
    status,
    currency,
    currentBillingAmountInCents,
    currentPeriodEndsAt,
    scheduledCancellationAt,
    nextAssessmentAt,
    canceledAt,
    expiresAt,
    trialEndedAt,
    balanceInCents,
    automaticallyResumeAt,
    product,
    billing,
    customFields,
    referralCode,
    threeDsActionLink,
    coupons,
    isLoading,
  };
};

export const subscriptionSelectors = {
  getSubscriptionState,
  getSubscriptionDetails,
  getCouponsStatus,
  getError,
  getAddedCoupon,
  getCoupons,
};
